import { Box, Button, Modal, TextField } from '@mui/material';
import React, { useState } from 'react';
import RouteModal from '../routeModal';
import EditDateModal from './editDateModal';
import VehiclesModal from './vehiclesModal';

const ViewUserModal = ({ isOpen, onClose, user, confirmFunction }) => {

    const [userEdited, setUserEdited] = useState(user);
    const [openRouteModal, setOpenRouteModal] = useState(false);
    const [openVehiclesModal, setOpenVehiclesModal] = useState(false);
    const [subAccountInput, setSubAccountInput] = useState('');

    const [isEditingStatus, setIsEditingStatus] = useState(false);

    const statuses = ['activo', 'suspendido', 'inactivo'];
    const availableStatuses = statuses.filter(s => s !== userEdited.status);

    const [isEditingDate, setIsEditingDate] = useState(false);

    const getSubAccountsKey = (userData) => {
        if (Object.prototype.hasOwnProperty.call(userData, 'subAccounts')) return 'subAccounts';
        if (Object.prototype.hasOwnProperty.call(userData, 'subaccounts')) return 'subaccounts';
        if (Object.prototype.hasOwnProperty.call(userData, 'subcuentas')) return 'subcuentas';
        if (Object.prototype.hasOwnProperty.call(userData, 'subCuentas')) return 'subCuentas';
        return 'subAccounts';
    };

    const subAccountsKey = getSubAccountsKey(user);
    const normalizeSubAccounts = (value) => Array.isArray(value) ? value : [];
    const subAccounts = normalizeSubAccounts(userEdited[subAccountsKey]);

    const parseSubAccountInput = (value) => {
        const trimmedValue = value.trim();
        return /^\d+$/.test(trimmedValue) ? Number(trimmedValue) : trimmedValue;
    };

    const subAccountExists = (value) => (
        subAccounts.some(subAccount => String(subAccount) === String(value))
    );

    const addSubAccount = () => {
        const newSubAccount = parseSubAccountInput(subAccountInput);

        if (newSubAccount === '' || subAccountExists(newSubAccount)) return;

        setUserEdited(prev => ({
            ...prev,
            [subAccountsKey]: [...subAccounts, newSubAccount]
        }));
        setSubAccountInput('');
    };

    const removeSubAccount = (subAccountToRemove) => {
        setUserEdited(prev => ({
            ...prev,
            [subAccountsKey]: normalizeSubAccounts(prev[subAccountsKey])
                .filter(subAccount => String(subAccount) !== String(subAccountToRemove))
        }));
    };

    const toggleEditStatus = () => setIsEditingStatus(!isEditingStatus);

    const changeStatus = (newStatus) => {
        const newData = { ...userEdited, status: newStatus };
        setUserEdited(newData);
        setIsEditingStatus(false);
    };

    // Función para convertir "DD/MM/YYYY" a un objeto Date
    const parseDate = (dateStr) => {
        const [day, month, year] = dateStr.split('/').map(Number);
        return new Date(year, month - 1, day);
    };

    // Función para obtener el color según la fecha de expiración
    const getExpirationColor = (dateStr) => {
        const expirationDate = parseDate(dateStr);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return expirationDate < today ? 'var(--color-danger)' : 'var(--color-success)';
    };


    // Función para obtener el color según el estatus
    const getStatusColor = (status) => {
        switch (status.toLowerCase()) {
            case 'activo':
                return 'var(--color-success)';
            case 'suspendido':
                return 'var(--color-warning)';
            case 'inactivo':
                return 'var(--color-danger)';
            default:
                return 'var(--color-dark)';
        }
    };

    // useEffect(() => {
    //     if (user) {
    //         setStatus(user.status);
    //     }
    // }, [user]);

    const updateRoute = (data) => {
        setUserEdited(prev => ({
            ...prev,
            route: data.route
        }));
    }

    const updateVehicles = (data) => {
        setUserEdited(prev => ({
            ...prev,
            vehicles: data.vehicles
        }));
    }

    const saveExpirationDate = (newExpirationDate) => {
        const [day, month, year] = newExpirationDate.split('/');
        const formatedDate = new Date(`${month}/${day}/${year}`);
        formatedDate.setHours(23, 59, 59, 999);
        
        setUserEdited(prev => ({
            ...prev,
            status: formatedDate < new Date() ? 'inactivo' : 'activo',
            expirationDate: newExpirationDate
        }));
    };

    // Determinar si hubo cambios y crear objeto con los valores modificados
    const getChangedValues = () => {
        const updatedData = { userId: user.userId }; // Siempre incluir userId
        const originalSubAccounts = normalizeSubAccounts(user[subAccountsKey]);
        const editedSubAccounts = normalizeSubAccounts(userEdited[subAccountsKey]);

        if (userEdited.status !== user.status) {
            updatedData.status = userEdited.status;
        }
        if (userEdited.expirationDate !== user.expirationDate) {
            updatedData.expirationDate = userEdited.expirationDate;
        }
        if (userEdited.route !== user.route) {
            updatedData.route = userEdited.route;
        }
        if (userEdited.vehicles !== user.vehicles) {
            updatedData.vehicles = userEdited.vehicles;
        }
        if (JSON.stringify(editedSubAccounts) !== JSON.stringify(originalSubAccounts)) {
            updatedData[subAccountsKey] = editedSubAccounts;
        }

        return updatedData;
    };

    // Determinar si el botón debe ser "Guardar" o estar deshabilitado
    const hasChanges = Object.keys(getChangedValues()).length > 1;

    return (
        <Modal open={isOpen} onClose={() => onClose(false)}>
            <Box className='view_user_modal_box'>
                <h2 style={{ textAlign: 'center', marginBottom: '0.3rem' }}>Datos del usuario</h2>
                <p><strong>Nombre: </strong>{userEdited.name}</p>
                <p><strong>Correo: </strong>{userEdited.email}</p>
                <p><strong>Id: </strong>{userEdited.userId}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', height: '0.7rem', color: 'var(--color-dark-variant)' }}>
                    <strong>Estatus: </strong>
                    <span style={{ color: getStatusColor(userEdited.status) }}>
                        {userEdited.status}
                    </span>
                    <div style={{ maxWidth: isEditingStatus ? '500px' : '0px', opacity: isEditingStatus ? 1 : 0, transition: 'max-width 0.5s ease, opacity 0.3s ease', overflow: 'hidden' }}>
                        {isEditingStatus && (
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                {availableStatuses.map((s) => (
                                    <Button
                                        key={s}
                                        onClick={() => changeStatus(s)}
                                        sx={{ color: getStatusColor(s), fontSize: '0.8rem', textTransform: 'lowercase' }}
                                    >
                                        {s}
                                    </Button>
                                ))}
                            </Box>
                        )}
                    </div>
                    <Button onClick={toggleEditStatus} sx={{ minWidth: 'auto' }}>
                        <span className="material-symbols-rounded" style={{ fontSize: 'large' }}>{isEditingStatus ? 'close' : 'edit'}</span>
                    </Button>
                </div>
                {/* Fecha de expiración con botón de edición */}
                <p style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <strong>Fecha de expiración: </strong>
                    <span style={{ color: getExpirationColor(userEdited.expirationDate) }}>
                        {userEdited.expirationDate}
                    </span>
                    <Button onClick={() => setIsEditingDate(true)} sx={{ minWidth: 'auto' }}>
                        <span className="material-symbols-rounded" style={{ fontSize: 'large' }}>edit</span>
                    </Button>
                </p>

                {/* Modal para editar la fecha de expiración */}
                {isEditingDate && userEdited && (
                    <EditDateModal isOpen={isEditingDate} onClose={setIsEditingDate} user={userEdited} saveExpirationDate={saveExpirationDate} />
                )}
                <p><strong>Etiqueta de ruta: </strong>{userEdited.geoTag}</p>
                <p>
                    <strong>Ruta: </strong>{userEdited.route.length}
                    <Button onClick={() => setOpenRouteModal(true)} sx={{ fontSize: '0.7rem', padding: '0 0.5rem', marginLeft: '0.5rem', minWidth: 'auto' }}>Ver</Button>
                </p>
                <RouteModal onOpen={openRouteModal} onClose={setOpenRouteModal} userRoute={userEdited.route} userUpdate={updateRoute} />
                <p>
                    <strong>Vehículos: </strong>{userEdited.vehicles.length}
                    <Button onClick={() => setOpenVehiclesModal(true)} sx={{ fontSize: '0.7rem', padding: '0 0.5rem', marginLeft: '0.5rem', minWidth: 'auto' }}>Ver</Button>
                </p>
                <VehiclesModal onOpen={openVehiclesModal} onClose={setOpenVehiclesModal} userVehicles={userEdited.vehicles} updateData={updateVehicles} />
                <Box>
                    <strong>Subcuentas: </strong>
                    <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {subAccounts.length > 0 ? (
                            subAccounts.map((subAccount, index) => (
                                <Box
                                    key={`${subAccount}-${index}`}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: 1,
                                        padding: '0.25rem 0.5rem',
                                        border: '1px solid var(--color-dark-variant)',
                                        borderRadius: '0.3rem',
                                        color: 'var(--color-dark)'
                                    }}
                                >
                                    <span>{subAccount}</span>
                                    <Button onClick={() => removeSubAccount(subAccount)} sx={{ minWidth: 'auto', padding: '0.1rem' }}>
                                        <span className="material-symbols-rounded" style={{ fontSize: 'large', color: 'var(--color-danger)' }}>delete</span>
                                    </Button>
                                </Box>
                            ))
                        ) : (
                            <span style={{ color: 'var(--color-dark-variant)', fontSize: '0.9rem' }}>Sin subcuentas</span>
                        )}
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="UserId de subcuenta"
                                value={subAccountInput}
                                autoComplete="off"
                                onChange={(e) => setSubAccountInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        addSubAccount();
                                    }
                                }}
                                helperText={subAccountInput.trim() !== '' && subAccountExists(parseSubAccountInput(subAccountInput)) ? 'Esta subcuenta ya esta vinculada.' : ''}
                                error={subAccountInput.trim() !== '' && subAccountExists(parseSubAccountInput(subAccountInput))}
                                sx={{
                                    '& .MuiInputLabel-root': {
                                        color: 'var(--color-dark)',
                                        fontSize: '0.8rem',
                                    },
                                    '& .MuiInputLabel-shrink': {
                                        fontSize: '1rem',
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: 'var(--color-dark-variant)',
                                        },
                                        '&:not(.Mui-focused):hover fieldset': {
                                            borderColor: 'var(--color-dark)',
                                        },
                                    },
                                    '& .MuiInputBase-input': {
                                        color: 'var(--color-dark)',
                                        fontSize: '0.8rem',
                                    },
                                }}
                            />
                            <Button
                                onClick={addSubAccount}
                                variant="contained"
                                disabled={subAccountInput.trim() === '' || subAccountExists(parseSubAccountInput(subAccountInput))}
                                sx={{ minWidth: 'auto', backgroundColor: 'var(--color-primary)', padding: '0.5rem' }}
                            >
                                <span className="material-symbols-rounded" style={{ fontSize: 'large' }}>add</span>
                            </Button>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button onClick={() => onClose(false)} color="primary">Cerrar</Button>
                    <Button
                        onClick={() => confirmFunction(getChangedValues())}
                        variant="contained"
                        disabled={!hasChanges}
                        sx={{
                            backgroundColor: 'var(--color-success)'
                        }}
                    >
                        Guardar
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ViewUserModal;
